<div class="weigh-transport-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc.weigh-transport-dialog.title"></sc-dictionary-label>
    </h2>


    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.name"
      [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <div class="weigh-transport-dialog-layout">
        <form #inputForm="ngForm" class="weigh-input-form">
          <sc-flex >
            <mat-form-field class="flex-grow-1" appearance="fill">
              <input name="value" matInput [(ngModel)]="value" #ctrlValue="ngModel" type="number" min="0" [max]="yardPropertiesService.getMaxWeight()"
                placeholder="{{'weight' | translate: ['tmc.weigh-transport-dialog.label.value', translationService.language]}}"
                [readonly]="false" required appPositiveInteger>
                @if (showValuePositiveIntegerError(ctrlValue)) {
                  <mat-error>
                    <sc-dictionary-label dictionaryKey="tmc.weigh-transport-dialog.error.value-no-integer"></sc-dictionary-label>
                  </mat-error>
                }
              </mat-form-field>
              <sc-content-spacer></sc-content-spacer>
              @if (isAutoWeighingVisible()) {
                <mat-form-field class="margin-left flex-grow-1" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc.weigh-transport-dialog.label.source"></sc-dictionary-label>
                  </mat-label>
                  <mat-select name="source" [(ngModel)]="source" #ctrlType="ngModel">
                    @for (o of sourceOptions; track o) {
                      <mat-option value="{{o}}">
                        <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.weighing.auto.sources.label.{{o}}"></sc-dictionary-label>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (yardPropertiesService.isWeighingEnabled() && isAutoWeighingVisible()) {
                <sc-button mat-icon-button class="weighingButton" (click)="readWeight()"
                  dictionaryKey="tmc.visit.overview.action.weighTransport"
                  >
                  <sc-icon iconClass="fa-balance-scale"></sc-icon>
                </sc-button>
              }
              <sc-content-spacer></sc-content-spacer>
              <mat-form-field class="margin-left flex-grow-1" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.common.type"></sc-dictionary-label>
                </mat-label>
                <mat-select name="type" [(ngModel)]="type" #ctrlType="ngModel" required>
                  @for (o of typeOptions; track o) {
                    <mat-option value="{{o}}">
                      <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.details.dialog.weighingType.{{o}}"></sc-dictionary-label>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </sc-flex>
            <sc-flex>
              @if (maxWeightExceeded()) {
                <sc-hint-legacy class="weighingError" [dictionaryKey]="'tmc.weigh-transport-dialog.error.weight-exceeded-error'" [type]="'error'"></sc-hint-legacy>
              }
            </sc-flex>
            <sc-flex >
              <mat-form-field class="date-field margin-left" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc.weigh-transport-dialog.label.date"></sc-dictionary-label>
                </mat-label>
                <input name="date" matInput [(ngModel)]="date" #ctrlDate="ngModel" type="date"
                  [readonly]="false" required>
                </mat-form-field>
                <sc-content-spacer></sc-content-spacer>
                <mat-form-field class="margin-left" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc.weigh-transport-dialog.label.time"></sc-dictionary-label>
                  </mat-label>
                  <input name="time" matInput [(ngModel)]="time" #ctrlTime="ngModel" type="time"
                    [readonly]="false" required>
                  </mat-form-field>
                  <sc-content-spacer></sc-content-spacer>
                  <sc-button class="margin-left add-button" (click)="addWeighing()"
                    [disabled]="isAddWeighingDisabled()"
                    dictionaryKey="tmc.weigh-transport-dialog.action.addWeighing">
                    <sc-icon iconClass="fa-plus"></sc-icon>
                  </sc-button>
                </sc-flex>
              </form>
              <div class="weigh-table-container">
                <sc-tmc-table [tableModel]="tableModel" [hideFilter]="true" #tmcTableComponent></sc-tmc-table>
              </div>
              <app-service-response [responseMessages]="responseMessages"></app-service-response>
            </div>
          </div>


          <div class="messages">
            <app-service-response [responseMessages]="responseMessages"></app-service-response>
          </div>

          <sc-actionbar>
            <sc-button class="confirm-button" (click)="createPrintout()"
              dictionaryKey="tmc-yard.ui.transport.details.dialog.weighings.action.createPrintout">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.details.dialog.weighings.action.createPrintout"></sc-dictionary-label>
              <sc-icon iconClass="fa-print"></sc-icon>
            </sc-button>
            <sc-content-spacer grow></sc-content-spacer>
            <button mat-stroked-button (click)="closeDialog()" [disabled]="isCloseDialogDisabled()">
              <sc-dictionary-label dictionaryKey="tmc.weigh-transport-dialog.action.close"></sc-dictionary-label>
            </button>
          </sc-actionbar>
        </div>
